import { Shimmer } from '@components';
import { StateMethods } from '@hookstate/core';
import { Icon as BlueIcon } from '@blueprintjs/core';

import {
  Overlay,
  Container,
  LoadingDiv,
  Header,
  Close,
  Divider,
  Line,
} from './EditEquipmentStatus.styles';

interface IEditEquipmentStatusLoading {
  open: StateMethods<boolean>;
}

const EditEquipmentStatusLoading = ({ open }: IEditEquipmentStatusLoading) => {
  return (
    <Overlay>
      <Container>
        <Header>
          <Shimmer
            style={{ height: 24, width: 178, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Close onClick={() => open.set(false)}>
            <BlueIcon icon="cross" color="#8F95B2" />
          </Close>
        </Header>

        <Divider />

        <LoadingDiv>
          <Shimmer
            style={{ height: 22, width: 65, borderRadius: 4, marginBottom: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{
              height: 42,
              width: '100%',
              borderRadius: 4,
              marginBottom: 24,
            }}
            primary="#f1f1f1"
            secondary="#ececec"
          />

          <Shimmer
            style={{ height: 22, width: 65, borderRadius: 4, marginBottom: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{
              height: 80,
              width: '100%',
              borderRadius: 4,
              marginBottom: 24,
            }}
            primary="#f1f1f1"
            secondary="#ececec"
          />

          <Shimmer
            style={{ height: 22, width: 65, borderRadius: 4, marginBottom: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{
              height: 42,
              width: '100%',
              borderRadius: 4,
              marginBottom: 24,
            }}
            primary="#f1f1f1"
            secondary="#ececec"
          />

          <Shimmer
            style={{ height: 22, width: 65, borderRadius: 4, marginBottom: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 22, width: 130, borderRadius: 4, marginBottom: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 22, width: 65, borderRadius: 4, marginBottom: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </LoadingDiv>

        <Line>
          <Shimmer
            style={{ height: 42, width: 61, borderRadius: 8, marginTop: 28 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </Line>
      </Container>
    </Overlay>
  );
};

export { EditEquipmentStatusLoading };
